import React, { useEffect, useState } from 'react';
import { Box, Button, TextField, Typography } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginStart } from '../../store/reducers/authSlice';
import { RootState } from '../../store';
import '../../styles/login.css';

const Login: React.FC = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [companyCode, setCompanyCode] = useState('');
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const { isAuthenticated, loading, error } = useSelector((state: RootState) => state.auth);

	useEffect(() => {
		if (process.env.REACT_APP_BYPASS_LOGIN === 'true') {
			navigate('/dashboard', { replace: true });
		}
	}, [navigate]);

	useEffect(() => {
		if (isAuthenticated) {
			navigate('/dashboard', { replace: true });
		}
	}, [isAuthenticated, navigate]);

	const onSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		dispatch(
			loginStart({ username, password, companyCode })
		);
	};

	return (
		<div className="login" style={{ position: 'relative', minHeight: '100vh' }}>
			<div
				id="bg-login"
				style={{
					position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
					backgroundImage: 'url(/images/background.jpg)',
					backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover',
					filter: 'blur(1px)', zIndex: 0,
				}}
			/>
			<div className="login_wrapper" style={{ position: 'relative', zIndex: 1 }}>
				<section className="login_form animate">
					<div className="login_content">
						<img src="/images/operoute-icon.png" alt="Operoute" height={64} />
						<h1>Welcome</h1>
						<form onSubmit={onSubmit}>
							<TextField id="companyCode" label="Company Code" variant="outlined" fullWidth margin="normal" value={companyCode} onChange={(e) => setCompanyCode(e.target.value)} />
							<TextField id="username" label="Email" type="email" variant="outlined" fullWidth margin="normal" value={username} onChange={(e) => setUsername(e.target.value)} />
							<TextField id="password" label="Password" type="password" variant="outlined" fullWidth margin="normal" value={password} onChange={(e) => setPassword(e.target.value)} />
							{error ? (<Typography color="error" variant="body2">{error}</Typography>) : null}
							<div><a className="reset_pass" href="#">Forgot your password?</a></div>
							<div className="separator" />
							<div><Button className="submit" color="primary" variant="contained" type="submit" disabled={loading}>Log in</Button></div>
							<div className="clearfix" />
						</form>
					</div>
				</section>
			</div>
		</div>
	);
};
export default Login; 